import { Card } from "@mui/material";
import { COLOR_VERY_LIGHT_GRAY } from "../../data/colors/Colors";

interface props {
  children: React.ReactElement;
  padding?: number;
  borderRadius?: number;
  background?: string;
  height?: number | string;
  minHeight?: number | string;
  maxHeight?: number | string;
  maxWidth?: number | string;
  width?: number | string;
  elevation?: number;
  border?: string;
}

export function CustomCardView(props: props) {
  return (
    <Card
      elevation={props.elevation ?? 0}
      sx={{
        background: props.background ?? COLOR_VERY_LIGHT_GRAY,
        p: props.padding ?? 3,
        borderRadius: props.borderRadius ?? 8,
        height: props.height,
        minHeight: props.minHeight,
        maxHeight: props.maxHeight,
        width: props.width,
        maxWidth: props.maxWidth,
        border: props.border,
      }}
    >
      {props.children}
    </Card>
  );
}
